import { SET_THEME, SET_USER_FILTER, CLEAR_USER_FILTER } from './types';

export const setNewTheme = (theme) => {
  return (dispatch) => {
    dispatch({
      type: SET_THEME,
      payload: theme
    });
  };
};

export const setUsedFilter = (user) => {
  return (dispatch) => {
    dispatch({
      type: SET_USER_FILTER,
      payload: user
    });
  };
};

export const clearUsedFilter = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_USER_FILTER,
      payload: {}
    });
  };
};
